module.exports = __webpack_public_path__ + "static/img/active7.bcd5ee10.png";